export default __webpack_public_path__ + "static/media/img4.f1191240.jpg";